// extracted by mini-css-extract-plugin
module.exports = {"heroBody":"hero_heroBody__XHjCM","title":"hero_title__PNuDE","subtitle":"hero_subtitle__tzTo7","cta":"hero_cta__8zmUE"};